import type { RouteObject } from "react-router-dom";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { AIAssistant } from "@/pages/(home)/(my-space)/ai-assistant";

export const DYNAMIC_SESSION_ID_KEY = "sessionId";

export enum MS_AI_ASSISTANT_PATH_SEGMENTS {
  ROOT = "ai-assistant",
  CHAT_SESSION = `:${DYNAMIC_SESSION_ID_KEY}`,
}

export const myspaceAIAssistantRoutes: RouteObject = {
  path: MS_AI_ASSISTANT_PATH_SEGMENTS.ROOT,
  HydrateFallback: Spinner, // TO BE MOVED TO TOP LEVEL OF ROUTES
  handle: { breadcrumb: "AI Assistant" },
  children: [
    {
      index: true,
      Component: AIAssistant,
    },
    {
      path: `:${DYNAMIC_SESSION_ID_KEY}`,
      handle: { breadcrumb: "Chat Session" },
      Component: AIAssistant,
    },
  ],
};

export const MS_AI_ASSISTANT_PATHS = Object.freeze({
  ROOT: addSlashes(MS_AI_ASSISTANT_PATH_SEGMENTS.ROOT),
  CHAT_SESSION: (sessionId: string) => addSlashes(MS_AI_ASSISTANT_PATH_SEGMENTS.ROOT, sessionId),
});
